module.exports = __webpack_public_path__ + "static/media/mountain3.8fad0322.jpg";